import {
    FETCH_SUPPLIER_RETURN,
    RESET_SUPPLIER_RETURN,
} from "../../constants/action.constants";

const initialState = {
    data: {},
    others: {
        total: 0,
        offset: 0,
        limit: 20,
    },
};

const supplierReturnReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SUPPLIER_RETURN:
            return { data: action.payload, others: action.others };
        case RESET_SUPPLIER_RETURN:
            return initialState;
        default:
            return state;
}
};

export default supplierReturnReducer;
  